import { useState, useEffect, useContext } from 'react';
import { ref, onValue, off } from 'firebase/database';
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { ParentContext } from 'global/cnr/contexts/ParentContext';

export function useRealtimeResults() {

  const appUserAccess = useAppUserAccess()
  const { uid, displayName } = appUserAccess ?? {}

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { app_state, paps_state } = states
  const { pathViews } = paps_state
  const { app_ts } = app_state

  const [realtimeResults, setRealtimeResults] = useState({});

  useEffect(() => {
    const submissionsRef = ref(app_ts.realtime, `matchResults/${pathViews.sports}/`);
    // Listen for live changes
    const unsubscribe = onValue(submissionsRef, (snapshot) => {
      setRealtimeResults({ realtimeResults: snapshot.val() || {} });
    });

    // Cleanup listener on unmount
    return () => off(submissionsRef);
  }, []);

  return realtimeResults;
}